import { UserFile } from '@/components/files/FilesOverviewPage';
import { resolveFileMimeType } from '@nordinsight/implant-core';
import { instance, GETREQUESTOPTIONS } from '../apiService';

interface uploadInfo {
    ownerType: string;
    filename: string;
    fileType: string;
    title?: string;
    manufacturerName?: string;
}

export const getUploadUrl = async (uploadInfo: uploadInfo) => {
    const { ownerType, filename, fileType, title } = uploadInfo;
    const res = await instance.post(
        '/api/files/upload-url',
        { ownerType, filename, fileType, title },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const getNIUploadUrl = async (uploadInfo: uploadInfo) => {
    const { ownerType, filename, fileType, title, manufacturerName } =
        uploadInfo;
    const res = await instance.post(
        '/api/files/ni-upload-url',
        { ownerType, filename, fileType, title, manufacturerName },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const getNIImplantUploadUrl = async (uploadInfo: uploadInfo) => {
    const { ownerType, filename, fileType, title, manufacturerName } =
        uploadInfo;
    const res = await instance.post(
        '/api/files/ni-implant-upload-url',
        { ownerType, filename, fileType, title, manufacturerName },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

// export const getDownloadUrl = async (type: string, filename: string) => {
//     const res = await instance.post(
//         '/api/files/download-url',
//         { type, filename },
//         GETREQUESTOPTIONS()
//     );
//     return res.data.url;
// };

export const uploadFile = async (uploadUrl: string, file: File) => {
    const mimeType = resolveFileMimeType({
        filename: file.name,
        mimeType: file.type,
    });
    try {
        const response = await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers: mimeType ? { 'Content-Type': mimeType } : undefined,
        });

        if (response.ok) {
            return 'OK';
        } else {
            return response.statusText;
        }
    } catch (error) {
        return error.toString();
    }
};

export const getAllManufacturerFiles = async () => {
    const response = await instance.get(
        '/api/files/all-manufacturer-files',
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getNordinsightFiles = async () => {
    const response = await instance.get(
        '/api/files/nordinsight-files',
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getManufacturerFiles = async (manufacturerName: string) => {
    const response = await instance.get(
        '/api/files/manufacturer-files/?manufacturerName=' +
            encodeURIComponent(manufacturerName),
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getUserFiles = async () => {
    const response = await instance.get(
        '/api/files/user-files',
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getDepartmentFiles = async () => {
    const response = await instance.get(
        '/api/files/department-files',
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const attachFilesToMRIMachine = async (
    machineId: string,
    fileIds: string[]
) => {
    const response = await instance.post(
        '/api/room-overview/attach-files',
        { machineId, fileIds },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const removeFileFromMRIMachine = async (
    machineId: string,
    fileId: string
) => {
    const response = await instance.post(
        '/api/room-overview/remove-file',
        { machineId, fileId },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const deleteFile = async (fileId: string) => {
    const response = await instance.post(
        '/api/files/delete-file',
        { fileId },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const renameFile = async (fileId: string, newFilename: string) => {
    const response = await instance.post(
        '/api/files/rename-file',
        { fileId, newFilename },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getDownloadUrl = async (fileId: string) => {
    const response = await instance.post(
        '/api/files/download-url',
        { fileId },
        GETREQUESTOPTIONS()
    );
    return response.data.url;
};

export const updateFileTitle = async (fileId: string, title: string) => {
    const response = await instance.post(
        '/api/files/update-title',
        { fileId, title },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getFileById = async (fileId: string): Promise<UserFile> => {
    const response = await instance.post(
        '/api/files/get-file-by-id',
        { fileId },
        GETREQUESTOPTIONS()
    );
    return response.data;
};
